const hasChildren = (items, id) => {
    const children = items.filter(item => {
        return item.menu_item_parent == id
    })

    if(children[0]) {
        return true
    } else {
        return false
    }
}

const nestedMenuItems = (items, parent = null) => {
    const parents = []
    const children = []

    items.map(item => {
        item.isFilter = false
        
        if(item.ID != parent && item.menu_item_parent == parent) {
            parents.push(item)
        } else {
            children.push(item)
        }
    })

    parents.map(parent => {
        if(hasChildren(children, parent.ID)) {
            parent.children = nestedMenuItems(children, parent.ID)
        }
    })

    return parents
}

const getItemChildren = (parentID, items, depth = true) => {
    let itemsList = []

    items.map(item => {
        if(item.menu_item_parent == parentID) {
            itemsList.push(formatMenuItem(item, true, itemsList))

            if(depth) {
                const children = getItemChildren(item.ID, itemsList)

                if(children) {
                    itemsList =  [...itemsList, ...children] // merge ??
                }
            }
        }
    })

    return itemsList
}

const formatMenuItem = (item, children = false, menu = []) => {
    if(true === children && menu[0]) {
        item.children = getItemChildren(item.ID, menu)
    }

    return item
}

const formatMenuItems = menuItems => {
    return nestedMenuItems(menuItems, 0)
}

export default formatMenuItems